import React from "react"
import hexagonImage from "../../images/leadership-hexagon.png"
import DynamicImage from "../common/DynamicImage"
import { HighlightText } from "../common/HighlightText"

const OurLeadership = ({data}) => {
  return (
    <>
      <section className="leadership-area ptb-70" data-aos="fade-up" data-aos-duration="1200">
        <div className="container">
          <div className="row align-items-center ">
            <div className="col-lg-6 col-md-12 order-lg-1 order-2">
              <div className="leadership-image text-center position-relative">
                <img src={hexagonImage} alt="Leadership Hexagon" style={{ maxWidth: "100%", height: "auto" }} />
                <div className="leadership-years-content text-center">
                  <DynamicImage image={data?.image} className="rounded-circle" />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 order-lg-2 order-1 text-lg-start text-center">
              <div className="leadership-content section-title">
                <h2 className="mb-1"><HighlightText content={data.title} /></h2>
                {data?.description?.map((block, i) => {
                if (block.type === "paragraph") {
                  return (
                    <p key={i}>
                      {block.children.map(c => c.text).join("")}
                    </p>
                  );
                }
                return null;
              })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default OurLeadership
